import { render, staticRenderFns } from "./orderiklandigital.vue?vue&type=template&id=80d4f730"
import script from "./orderiklandigital.vue?vue&type=script&lang=js"
export * from "./orderiklandigital.vue?vue&type=script&lang=js"
import style0 from "./orderiklandigital.vue?vue&type=style&index=0&id=80d4f730&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports